import {BaseSingleInputComponent, BaseSingleInputComponentController} from "../baseSingleInput.component";

export class ReadonlyTextComponent extends BaseSingleInputComponent {
    protected getController(): typeof BaseSingleInputComponentController {
        return ReadonlyTextComponentController;
    }

    protected getTemplateUrl(): string {
        return './modules/quoteWizard/components/singleInputComponents/readonlyText/readonlyText.view.html';
    }

    protected getBindings(): any {
        return {};
    }
}

// internal interface between the component and the controller -- this is the controller's API
interface IReadonlyTextInputComponentController {
    goNext(): void;

    goBack(): void;
}

// tslint:disable-next-line:max-classes-per-file
export class ReadonlyTextComponentController extends BaseSingleInputComponentController implements IReadonlyTextInputComponentController {
}
